import { PledgeSummaryResponse } from '@http/api-models/PledgeSummaryResponse'
import { apiUrls } from '@http/api-urls'
import { httpService } from '@http/service'
import { NextPageFC } from '@shared/models/next-fc'
import { GetServerSideProps } from 'next'
import { InvestorsFond, InvestorsFondPageProps } from 'screens/investors-fond'

import { RegionalPagesPath, regionalPagesProps } from '../regions/runtime-components/pages-props'
import { getSavingsParams } from '../ssr-resolvers/savings-params'

const InvestPage: NextPageFC<InvestorsFondPageProps> = (props) => InvestorsFond(props)

InvestPage.layout = regionalPagesProps[RegionalPagesPath.invest].layout
InvestPage.headProps = regionalPagesProps[RegionalPagesPath.invest].headProps
InvestPage.breadcrumb = { title: 'Сбережения' }

export const getServerSideProps: GetServerSideProps<InvestorsFondPageProps> = async () => {
	try {
		const [pledgeSummary, savingsParams] = await Promise.all([
			httpService.get<PledgeSummaryResponse>(apiUrls.getSummaries()),
			getSavingsParams(),
		])

		const result = {
			props: {
				pageSettings: {
					savings: { params: savingsParams },
					pledgeSummary: pledgeSummary,
				},
			},
		}
		return result
	} catch {
		return {
			props: {
				pageSettings: {},
			},
		}
	}
}

export default InvestPage
